import React, { Component } from 'react';

import {
  VisibilitySensor,
} from '../coreui';
import FadeInChildren from './FadeInChildren';

class FadeIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
    this.handleSensorChange = this.handleSensorChange.bind(this);
  }

  handleSensorChange(isVisible) {
    if (isVisible) {
      this.setState({
        isVisible: true,
      });
    }
  }

  render() {
    const isVisible = this.state.isVisible;

    return (
      <React.Fragment>
        <VisibilitySensor
          callback={this.handleSensorChange}
        />
        <FadeInChildren isVisible={isVisible} {...this.props} />
        <VisibilitySensor
          callback={this.handleSensorChange}
        />
      </React.Fragment>
    );
  }
}

export default FadeIn;
